var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isPreview
        ? _c("div", [
            _c("input", {
              staticClass: "form-control disabled",
              attrs: {
                disabled: true,
                placeholder: "Escribe tu respuesta",
                type: "number",
                value: "0"
              }
            })
          ])
        : _c("custom-input", {
            attrs: {
              disabled: _vm.isReadOnly,
              placeholder: "Escribe tu respuesta",
              type: "number"
            },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }